export default __webpack_public_path__ + "static/ops-6164de30281317c24f0cd672f37027b2.png";